import type config from '@config/index';

export enum OnboardingTaskId {
  CateringLeadPinned = 'catering-lead-pinned',
  CateringLeads = 'catering-leads',
  CateringLeadsGenerating = 'catering-leads-generating',
  CreateCatalog = 'create-catalog',
  CreateInvoice = 'create-invoice',
  CreateTransaction = 'create-transaction',
  DownloadApp = 'download-app',
  EventLeadPinned = 'event-lead-pinned',
  EventLeads = 'event-leads',
  EventLeadsGenerating = 'event-leads-generating',
  OnlineOrdering = 'online-ordering',
  Pos = 'pos',
  Quotes = 'quotes',
  ReviewInvoiceReports = 'review-invoice-reports',
  ReviewTransactionReports = 'review-transaction-reports',
  SetSchedule = 'set-schedule',
  SetTaxSettings = 'set-tax-settings',
  StripeConnect = 'stripe-connect',
  VenueLeadPinned = 'venue-lead-pinned',
  VenueLeads = 'venue-leads',
  VenueLeadsGenerating = 'venue-leads-generating',
  Website = 'website',
  WebsiteDefaultMenu = 'website-default-menu',
  WebsiteLogo = 'website-logo',
  WebsitePublish = 'website-publish',
}
export interface OnboardingTask {
  busy?: boolean;
  hasOptions?: boolean;
  id: OnboardingTaskId;
  label: string;
  description?: string;
  hide?: boolean;
  href?: string;
  onClick?: () => void;
  isComplete?: boolean;
}

export type OnboardingTaskStatus = 'pending' | 'completed' | 'hidden';
export type OnboardingTaskStatusMap = Record<
  OnboardingTaskId,
  OnboardingTaskStatus
>;

export type FeatureId = ValuesOf<typeof config.features>;
export interface OnboardingFeature {
  busy?: boolean;
  id: FeatureId;
  hide?: boolean;
  title: string;
  tasks: OnboardingTask[];
}

export interface OnboardingWidgetProps {
  className?: string;
}

export interface OnboardingWidgetState {
  isCollapsed: boolean;
  isClosed: boolean;
  completedTasks: string[];
}
